import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material';

export class SmartStyle {
    public icon?: string;
    public img?: string;
    public css_class?: string | string[];
    public text_styles?: any;
    public icon_styles?: any;
    public clickable?: boolean;
}

/**
 * Inline component to show a text label with an optional icon.
 * <br>
 * Useful to apply standardized styles across multiple components whilest keeping central control.
 */
@Component({
    selector: 'styled-span',
    templateUrl: './styled.span.html'
})
export class StyledSpan {

    /**
     * The visual style to apply.
     * <ul>
     * <li>css_class: string | string[]: class name (or array of class names)</li>
     * <li>text_styles: css style object</li>
     * <li>icon_styles: css style object</li>
     * <li>clickable: boolean: enabled or disabled</li>
     * <li>icon: string: name of material icon</li>
     * <li>img: string: url of image to show instead of an icon</li>
     * </ul>
     */
    @Input('style')
    style: SmartStyle = {
        css_class: [],
        text_styles: {
        },
        icon_styles: {
        },
        clickable: null,
        icon: null,
        img: null
    }

    @ViewChild('span', {static: true})
    span: ElementRef;

    @ViewChild('icon', {static: true})
    icon: MatIcon;

    @ViewChild('text', {static: true})
    text: ElementRef;

    ngOnInit() {
        this.apply(this.style);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.apply(this.style);
    }

    apply(style: SmartStyle) {
        if (!style) style = {}
        this.style = style;

        if (this.span && this.span.nativeElement && style.css_class) {
            let classes = [].concat(style.css_class)
            for(let c of classes) {
                this.span.nativeElement.classList.add(c)
            }
        }
        // if (this.text && this.text.nativeElement && style.text_styles) {
        //     for(let key in style.text_styles) {
        //         this.text.nativeElement.style.key = style.text_styles[key]
        //     }
        // }
        // if (this.icon && this.icon._elementRef.nativeElement && style.icon_styles) {
        //     for(let key in style.icon_styles) {
        //         this.icon._elementRef.nativeElement.style.key = style.icon_styles[key]
        //     }
        // }
        if (this.span && this.span.nativeElement && style.clickable) {
            this.span.nativeElement.style.cursor = 'pointer'
        }
    }
}